import { t } from "@lingui/macro"
import { FormControlLabel, Radio, RadioGroup } from "@mui/material"
import { observer } from "mobx-react"
import { useCallback } from "react"

import { FormFieldSet } from "src/components/FormFieldSet"
import { CommunitySelect } from "src/modals/community-posts-and-comments-edit/formFields/CommunitySelect"
import { CommunityPostsAndCommentsEditStore } from "src/modals/community-posts-and-comments-edit/store"
import { GlobalStore } from "src/store"
import { useStore } from "src/store/lib/useStore"
import { DateTimePicker } from "src/components/DateTimePicker"

export const SettingsSection = observer(() => {
    const gstore = useStore(GlobalStore)
    const store = useStore(CommunityPostsAndCommentsEditStore)

    const handlePinChange = useCallback(
        (_: unknown, value: string) => {
            store.form.set("pin", value === "true")
        },
        [store],
    )

    const handlePublishAtChange = useCallback(
        (date: Date | null) => store.form.set("publishAt", date),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    )

    return (
        <>
            <FormFieldSet
                header={t`community-post-detail-modal.settings-section.community-header`}
            >
                <CommunitySelect />
            </FormFieldSet>

            <FormFieldSet
                header={t`community-post-detail-modal.schedule-section.header`}
                tooltip={t`community-post-detail-modal.schedule-section.tooltip`}
            >
                <DateTimePicker
                    data-testid="publish-at"
                    value={store.form.get("publishAt")}
                    onChangePicker={handlePublishAtChange}
                    minDate={new Date()}
                    error={Boolean(store.form.error("publishAt"))}
                    helperText={store.form.error("publishAt")}
                    inputId="publish-at"
                    disabled={store.isReadOnly}
                />
            </FormFieldSet>

            {gstore.features.enabled("ShowCommunityPostPinnedCheckbox") && (
                <FormFieldSet
                    header={t`community-post-detail-modal.settings-section.pinned-header`}
                >
                    <RadioGroup
                        value={store.form.get("pin")}
                        onChange={handlePinChange}
                        row
                    >
                        <FormControlLabel
                            control={<Radio value={true} />}
                            label={t`community-post-detail-modal.settings-section.pinned-yes`}
                            disabled={store.form.get("accessType") === "READ"}
                        />
                        <FormControlLabel
                            control={<Radio value={false} />}
                            label={t`community-post-detail-modal.settings-section.pinned-no`}
                            disabled={store.form.get("accessType") === "READ"}
                        />
                    </RadioGroup>
                </FormFieldSet>
            )}
        </>
    )
})
